module.exports = __webpack_public_path__ + "static/waves-form-dbf71142d493aeeaf42ab7dd08e5a61b.svg";